import { TypeTabNavigationWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import TabNavigation from './TabNavigation'

const ContentfulTabNavigation = withContentful<TypeTabNavigationWithoutUnresolvableLinksResponse['fields']>(
  TabNavigation,
  {
    sysID: (props) => props.sys.id,
    entryTitle: (props) => props.fields.entryTitle,
    tabNavigationLinks: (props) => {
      return props.fields.tabNavigationLinks.map((tabNavigationLink) => ({
        id: tabNavigationLink.sys.id,
        linkText: tabNavigationLink.fields.linkText,
        linkId: tabNavigationLink.fields.linkId,
      }))
    },
  }
)

export default ContentfulTabNavigation
